import React, { useEffect, useState } from 'react'
import { ApiGetReCheckList, ApiUpdateReCheckList } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify';
import { Avatar, Box, Button, Typography } from '@mui/material'
import Loading from '../../Loader/Loading.tsx';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

function ReCheck() {

    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const [ReCheckList, setReChecklist] = useState<any>([])
    const loading = useSelector((state: any) => state.loader.isLoading);


    const ReCheck = async () => {
        try {
            const data = `?userId=${userData.userId}`
            const res = await ApiGetReCheckList(data)
            setReChecklist(res.data)

        } catch (error:any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }

    useEffect(() => {
        ReCheck()
    }, [])

    const handleUpdateDateTime = async (allocationId:number, status:boolean) => {

        try {
            const data = {
                "allocationId": allocationId,
                "userId": userData.userId,
                "approve": status
            }
            const res = await ApiUpdateReCheckList(data)
            ReCheck()

        } catch (error:any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }


    return (
        <div>
            <Box
                maxHeight="calc(100vh - 140px)"
                sx={{ overflow: "auto" }}
                height="100%"
                // maxHeight={}
                display={'block'}
                overflow="auto"
            >
                <Box flexDirection={{ xs: 'column', lg: 'row' }} className="d-flex flex-wrap" p={{ xs: 2, lg: 3 }} gap={2} width='100%'>
                    {ReCheckList?.length > 0 ? ReCheckList?.map((item:any, index:number) => (
                        <Box flex={1} minWidth='25%' className='border p-2  p-lg-3 mb-1 d-flex flex-column border-10' gap={1}>
                            <Box className='d-flex align-items-center' gap={2}>
                                <Avatar src={item?.allocationId?.venueId?.logoUrl}>
                                </Avatar>
                                <Box>
                                    <Typography variant='h6' fontWeight='bold'>{item?.allocationId?.venueId?.venueName}</Typography>
                                    <Typography variant='caption' className='bg-second px-3 py-1 text-light' borderRadius='5px'>{item?.allocationId?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant='caption' fontWeight='700'>Address:</Typography>
                                <Typography variant='subtitle2' fontWeight='700'>{item?.allocationId?.venueId?.address}</Typography>
                            </Box>
                            <Box className='d-flex align-items-start justify-content-between'>
                                <Box className='col-6'>
                                    <Typography variant='caption' fontWeight='700'>Selected Visit Date:</Typography>
                                    <Typography className='second-text' variant='subtitle2' fontWeight='700'>{dayjs(item?.selectedVisitDate).format('DD/MM/YYYY')}</Typography>
                                </Box>
                                <Box className='col-6'>
                                    <Typography variant='caption' fontWeight='700'>Selected Visit Time:</Typography>
                                    <Typography className='second-text' variant='subtitle2' fontWeight='700'>{item?.selectedVisitTime?.visitTimeInformation}</Typography>
                                </Box>
                            </Box>
                            <Box className='d-flex align-items-start justify-content-between'>
                                <Box className='col-6'>
                                    <Typography variant='caption' fontWeight='700'>New Visit Date:</Typography>
                                    <Typography className='third-text' variant='subtitle2' fontWeight='700'>{dayjs(item?.requestedNewVisitDate).format('DD/MM/YYYY')}</Typography>
                                </Box>
                                <Box className='col-6'>
                                    <Typography variant='caption' fontWeight='700'>New Visit Time:</Typography>
                                    <Typography className='third-text' variant='subtitle2' fontWeight='700'>{item?.requestedNewVisitTime?.visitTimeInformation}</Typography>
                                </Box>
                            </Box>
                            <Box className="d-flex gap-2">
                                <Button
                                    variant="outlined"
                                    className={" button-secondary-outlined py-2 px-auto transform"}
                                    onClick={() => {
                                        handleUpdateDateTime(item?.allocationId?.allocationId, false);
                                    }}
                                    fullWidth
                                >
                                    Reject
                                </Button>
                                <Button
                                    variant="contained"
                                    className={"py-2 px-auto transform button-primary"}
                                    fullWidth
                                    onClick={() => {
                                        handleUpdateDateTime(item?.allocationId?.allocationId, true);
                                    }}
                                >
                                    Approve
                                </Button>
                            </Box>
                        </Box>
                    )) : <Typography variant='h4' className='text-center w-100 p-2' fontWeight='900'>There is nothing for you to action at present.</Typography>}
                    {loading && <Loading />}
                </Box>
            </Box>
        </div>
    )
}

export default ReCheck
